import { render, staticRenderFns } from "./OrdinanceDetail.vue?vue&type=template&id=503fc8d2&scoped=true&"
import script from "./OrdinanceDetail.vue?vue&type=script&lang=ts&"
export * from "./OrdinanceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OrdinanceDetail.vue?vue&type=style&index=0&id=503fc8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503fc8d2",
  null
  
)

export default component.exports